import React, { Component } from 'react';
import '@google/model-viewer';

// Require context model folder
const models = require.context('../assets/models', true);


class ModelViewerCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            androidModel: '',
            iosModel: ''
        };
    }

    componentDidMount() {
        this.setState({
            name: this.props.model.name,
            androidModel: models(`./${this.props.model.androidModel}`), 
            iosModel: models(`./${this.props.model.iosModel}`), 
        }); 
        
    }


    render() {
        return (
            <div>
                <model-viewer
                    id="modelViewer"
                    ar
                    ar-scale="auto"
                    src={this.state.androidModel}
                    ios-src={this.state.iosModel}
                    camera-controls>
                    {/* <button slot="hotspot-visor" data-position="0 1.75 0.35" data-normal="0 0 1"></button> */}
                </model-viewer>
                <div id="annotation">{this.state.name}</div>
            </div>
        );
    }
}

export default ModelViewerCard;
